import { render, staticRenderFns } from "./CategoryFriendInfo.vue?vue&type=template&id=63cc640e&scoped=true"
import script from "./CategoryFriendInfo.vue?vue&type=script&lang=ts"
export * from "./CategoryFriendInfo.vue?vue&type=script&lang=ts"
import style0 from "./CategoryFriendInfo.vue?vue&type=style&index=0&id=63cc640e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cc640e",
  null
  
)

export default component.exports